import { gql } from '@apollo/client';

export const GET_IS_BONUSES_TUTORIAL_SHOWN = gql`
  query GetIsBonusesTutorialShown {
    user @client {
      isBonusesTutorialShown
    }
  }
`;
